'use strict';

angular.module('TurneroApp').component('coEncuestas', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'encuestasService',
        'utilsService',
        'TurneroAppConstant',
        function (encuestasService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.accion = null;
            ctrl.encuestas = [];
            ctrl.focusBuscar = false;
            ctrl.filter = false;
            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.acciones = TurneroAppConstant.Acciones;
            ctrl.estados = TurneroAppConstant.Estados.Encuesta;

            ctrl.$onInit = function () {
                ctrl.limpiarFiltro();
            }

            ctrl.$onChanges = function () {
                ctrl.centroAtencionSeleccionado.id && ctrl.grillaReload();
            };

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.limpiarFiltro = function () {
                ctrl.query = {
                    page: 1,
                    limit: 10,
                    filter: "",
                    Id_Estado: "",
                    Id_Tramite: "",
                };
            };

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.limpiarMemoria = function () {
                ctrl.accion = null;
            };

            ctrl.grillaReload = function () {
                ctrl.loadFiltros();
                ctrl.limpiarMemoria();
                //si tiene un texto de busqueda que sea mayor a 2 caracteres
                if (ctrl.query.filter.length > 2 || ctrl.query.filter.length == 0) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);
                }
            };

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.encuestas = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObject = data.Data;
                    ctrl.arrayExport = [];
                    ctrl.arrayExport[0] = ['Orden', 'Encuesta'];
                    for (var i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            i,
                            arrayObject[i].Nombre
                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Encuestas',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            ctrl.getData = function (page, limit, tipo, callback) {
                ctrl.promise = encuestasService.GetListado({
                    'filtro.Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id,
                    'filtro.Id_Estado': ctrl.query.Id_Estado,
                    'filtro.Id_Tramite': ctrl.query.Id_Tramite,
                    'filtro.Id_Agenda': ctrl.query.Id_Agenda,
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter,
                }).$promise.then(function (res) {
                    callback(tipo, res);
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            }

            ctrl.loadFiltros = function () {
                encuestasService.GetFiltros({
                    'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                }).$promise.then(function (resultado) {
                    ctrl.Filtros = resultado.Data
                }).catch(function (error) {
                    utilsService.errores(error);
                })
            };

            ctrl.crear = function () {
                ctrl.limpiarMemoria();
                ctrl.accion = TurneroAppConstant.Acciones.Crear;
                ctrl.tLoadWizard(ctrl.accion);
            };

            ctrl.modificar = function (item) {
                ctrl.limpiarMemoria();
                ctrl.accion = TurneroAppConstant.Acciones.Editar;
                ctrl.tLoadWizard(ctrl.accion, item);
            };

            ctrl.ver = function (item) {
                ctrl.limpiarMemoria();
                ctrl.accion = TurneroAppConstant.Acciones.Ver;
                ctrl.tLoadWizard(ctrl.accion, item);
            };

            ctrl.historial = function (item) {
                ctrl.limpiarMemoria();
                ctrl.accion = TurneroAppConstant.Acciones.VerHistorial;
                ctrl.tLoadHistorial(item);
            };

            ctrl.eliminar = function (item) {
                swal({
                    title: "Eliminar Encuesta",
                    text: "¿Desea quitar la Encuesta?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#e77a1e",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!"
                }).then(function () {
                    encuestasService.cambiarEstado({ 'Id_Encuesta': item.Id_Encuesta, 'Id_Estado_Nuevo': ctrl.estados.Eliminada }).$promise.then(function (res) {
                        ctrl.grillaReload();
                        swal("Eliminado!", "La Encuesta ha sido borrada correctamente.", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });

                });
            };

            ctrl.habilitar = function (item) {
                if (item.Id_Estado == ctrl.estados.Habilitada) {
                    swal({
                        title: '¿Inhabilitar encuesta?',
                        html: '¿Desea inhabilitar la encuesta "' + item.Nombre + '"?',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#e77a1e',
                        cancelButtonColor: '#AAA5A5',
                        confirmButtonText: '¡Sí, inhabilitarla!',
                        cancelButtonText: 'No, cancelar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function () {
                        utilsService.swalNotification('Procesando', 'Cambiando estado de encuesta: ' + item.Nombre, 'info');

                        encuestasService.cambiarEstado({
                            'Id_Encuesta': item.Id_Encuesta, 'Id_Estado_Nuevo': ctrl.estados.Inhabilitada
                        }).$promise.then(function (result) {
                            swal({
                                title: '¡Inhabilitada!',
                                text: 'Se ha inhabilitado la encuesta.',
                                type: 'success',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: 'Aceptar',
                                allowEscapeKey: false,
                                allowOutsideClick: false
                            }).then(function (result) {
                                ctrl.grillaReload();
                            });
                        }).catch(function (error) {
                            swal.close();
                            utilsService.errores(error);
                        })
                    })
                } else if (item.Id_Estado == ctrl.estados.Inhabilitada) {
                    swal({
                        title: '¿Habilitar encuesta?',
                        html: '¿Desea habilitar la encuesta "' + item.Nombre + '"?',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#e77a1e',
                        cancelButtonColor: '#AAA5A5',
                        confirmButtonText: '¡Sí, habilitarla!',
                        cancelButtonText: 'No, cancelar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function () {
                        utilsService.swalNotification('Procesando', 'Cambiando estado de encuesta: ' + item.Nombre, 'info')

                        encuestasService.cambiarEstado({
                            'Id_Encuesta': item.Id_Encuesta, 'Id_Estado_Nuevo': ctrl.estados.Habilitada
                        }).$promise.then(function (result) {

                            //swal.close();
                            swal({
                                title: '¡Habilitada!',
                                text: 'Se ha habilitado la encuesta.',
                                type: 'success',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: 'Aceptar',
                                allowEscapeKey: false,
                                allowOutsideClick: false
                            }).then(function (result) {
                                ctrl.grillaReload();
                            });
                        }).catch(function (error) {
                            swal.close();
                            utilsService.errores(error);
                        })
                    })
                }
            };
        }
    ],
    template: require('./encuestas.html')
});



// WEBPACK FOOTER //
// ./app/components/supervision/encuestas/encuestasComponent.js